import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { pageTitle, translateApp, useTranslation } from '@/lib/i18n'
import { CorrectionsWorkspace } from '@/modules/corrections/components/corrections-workspace'
import {
	globalCorrectionSearchSchema,
	stripRemovedCorrectionFilters
} from '@/modules/corrections/data/view'

export const Route = createFileRoute('/(private)/corrections')({
	component: CorrectionsPage,
	validateSearch: globalCorrectionSearchSchema,
	search: {
		middlewares: [
			stripRemovedCorrectionFilters,
			stripSearchParams(globalCorrectionSearchSchema.parse({}))
		]
	},
	staticData: { breadcrumb: 'po:corrections.title' },
	head: () => ({
		meta: [{ title: pageTitle(translateApp('it', 'po:corrections.title')) }]
	})
})

function CorrectionsPage() {
	const { t } = useTranslation()
	return (
		<div className='flex h-full min-h-0 flex-col'>
			<header className='px-4 pt-5 pb-2 md:px-6'>
				<h1 className='font-semibold text-2xl tracking-tight'>
					{t('po:corrections.title')}
				</h1>
				<p className='mt-1 text-muted-foreground text-sm'>
					{t('po:corrections.description')}
				</p>
			</header>
			<CorrectionsWorkspace />
		</div>
	)
}
